export default __webpack_public_path__ + "static/media/mc-w-card.20ed7718.png";